import cn from 'clsx'

import './Meter.scss'

interface MeterProps {
  size?: 'medium' | 'small'
  color?:
    | 'default'
    | 'green'
    | 'black'
    | 'coal'
    | 'turquoize'
    | 'blacky'
    | 'greeny'
  width?: number
  value: number
}

export default function Meter({
  size = 'medium',
  color = 'default',
  width,
  value,
}: MeterProps) {
  const lineStyle = {width: `${value < 100 ? value : 100}%`}

  return (
    <div
      className={`Meter Meter_color_${color} Meter_size_${size}`}
      style={width ? {width} : undefined}
    >
      <div className="Meter-Line" />
      <div
        className={cn(
          'Meter-Line Meter-Line_fill',
          !value && 'Meter-Line_fillEmpty'
        )}
        style={lineStyle}
      />
    </div>
  )
}
